module.exports = __webpack_public_path__ + "img/individual_weddingrings_ring_1.e06ca90.webp";